module.exports = __webpack_public_path__ + "78a9fb3e5331ebfb77f0d478dfca705b.jpg";